import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { MfaEnrollPage } from '../../auth/mfa-enroll-page';

/**
 * `/mfa/enroll` (M2.8, SECURITY.md §4.3).
 *
 * Reachable before enrolment is complete, which is why it is in `MFA_ENROLMENT_PATHS`
 * and renders outside the shell. `RequireAuth` still applies through the root layout's
 * bare branch only in the sense that an anonymous visitor here has nothing to enrol -
 * the API answers `401` on the first call and the client puts them back to `/login`.
 */
export const Route = createFileRoute('/mfa/enroll')({
  component: MfaEnrollRoute,
});

function MfaEnrollRoute() {
  const navigate = useNavigate();
  return (
    <MfaEnrollPage
      onDone={() => {
        void navigate({ to: '/', replace: true });
      }}
    />
  );
}
